jQuery(document).ready(function($) {

    $('.entry-thumbnail').each(function () {
        var $container = $(this);
        var $hoverTarget = $container.closest('a');
        var videoId = $container.data('video-id');
    
        // data-video-id が存在しない場合はスキップ
        if (!videoId) return;
    
        var iframeInserted = false;
    
        $hoverTarget.on('mouseenter', function () {
          if (iframeInserted) return;
    
          var $iframe = $('<iframe>', {
            src: 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&controls=0&showinfo=0&rel=0',
            frameborder: 0,
            allow: 'autoplay; encrypted-media',
            allowfullscreen: true,
            css: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }
          });
    
          $container.append($iframe);
          iframeInserted = true;
        });
    
        $hoverTarget.on('mouseleave', function () {
          $container.find('iframe').remove();
          iframeInserted = false;
        });
      });


    // スライダーの初期化
    if ($('.slider-wrapper').length) {
        $('.slider-wrapper').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            centerMode: true,
            centerPadding: "20%",
            variableWidth: true,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }

    if ($('.youtube-recommend-content').length) {
        $('.youtube-recommend-content').slick({
            autoplay: true,
            autoplaySpeed: 8000,
            centerMode: true,
            centerPadding: "0%",
            variableWidth: true,
            arrows: true,
            dots: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }

    if ($('.books-slider-content').length) {
        $('.books-slider-content .posts-grid').slick({
            autoplay: false,
            arrows: true,
            dots: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }

    $('.youtube-recommend-content').on('afterChange', function(event, slick, currentSlide, nextSlide){
        // 中央以外のスライドのiframeを削除
        $('.youtube-thumbnail').not('.slick-center .youtube-thumbnail').find('iframe').remove();
        
        var $container = $(".slick-center").find(".youtube-thumbnail");
        var videoId = $container.data('video-id');
        console.log(videoId);
        var $iframe = $('<iframe>', {
            src: 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&controls=0&showinfo=0&rel=0',
            frameborder: 0,
            allow: 'autoplay; encrypted-media',
            allowfullscreen: true,
            css: {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }
          });
        $container.append($iframe);
        iframeInserted = true;
      });

    var beforePos = 0;//スクロールの値の比較用の設定
    var body = $('body'); // body変数を定義
    
    //スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
    function ScrollAnime() {
        var elemTop = 300;//#area-2の位置まできたら
        var scroll = $(window).scrollTop();
        //ヘッダーの出し入れをする
        if(scroll == beforePos) {
        //IE11対策で処理を入れない
        }else if(elemTop > scroll || 0 > scroll - beforePos){
        //ヘッダーが上から出現する
        $('.site-header').removeClass('UpMove'); //#headerにUpMoveというクラス名を除き
        $('.site-header').addClass('DownMove');//#headerにDownMoveのクラス名を追加
        }else {
        //ヘッダーが上に消える
        $('.site-header').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
        $('.site-header').addClass('UpMove');//#headerにUpMoveのクラス名を追加
        }
        
        beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
    }

    // 画面をスクロールをしたら動かしたい場合の記述
    $(window).scroll(function () {
        ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
    });

    // ページが読み込まれたらすぐに動かしたい場合の記述
    $(window).on('load', function () {
        ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
    });

    //note-ringの初期化
    function initNoteRing(){
        $('.note-ring').each(function(){
            var noteRing = $(this);
            var noteRingWidth = noteRing.width();
            var noteRingCount = Math.ceil(noteRingWidth / 44);
            noteRing.empty();
            for(var i = 0; i < noteRingCount; i++){
                noteRing.append('<span class="note-ring-item"></span>');
            }
        });
    }

    // ウィンドウリサイズ時にも再計算
    $(window).on('resize', function(){
        initNoteRing();
    });

    // 初期化
    initNoteRing();

    //リンク先のidまでスムーススクロール
    //※ページ内リンクを行わない場合は不必要なので削除してください
    var headerH = $("#header").outerHeight(true);//headerの高さを取得    
    $('#g-navi li a').click(function () {
        var elmHash = $(this).attr('href'); 
        var pos = $(elmHash).offset().top-headerH;//header分の高さを引いた高さまでスクロール
        $('body,html').animate({scrollTop: pos}, 1000);
        return false;
    });

    //フォームの遷移
    // フォームのdiv取得
    var mwwpform = $('.mw_wp_form');
    // .errorを取得
    var error = $('.error');
    // 最初の入力項目を取得
    var inputValue = $('.mw_wp_form input').first();
    // スクロール位置の調整用オフセット（必要に応じて変更可能）
    var scrollOffset = -60;
    
    // 条件分岐
    if (!mwwpform.hasClass('mw_wp_form_input')) {  // 入力画面以外の場合のみスクロールを実行
        if(body.hasClass('logged-in')){
            if(mwwpform.hasClass('mw_wp_form_confirm')){
                scrollToRequestForm();
            } else if (inputValue.val() !== '') {
                scrollToRequestForm();
            } else if (mwwpform.hasClass('mw_wp_form_complete')) {
                scrollToRequestForm();
            }
        }
    }else if(error.length) {
        scrollToRequestForm();
    }
    
    // #request-formへのスクロール関数
    function scrollToRequestForm() {
        var requestForm = $('#request-form');
        if (requestForm.length) {
            var position = requestForm.offset().top + scrollOffset;
            window.scrollTo(0, position);
        } else {
            // フォールバック：#request-formが見つからない場合は元の動作
            window.scrollTo(0, mwwpform[0].getBoundingClientRect().top);
        }
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const favoriteIcons = document.querySelectorAll('.favorite-icon');
  
    favoriteIcons.forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        // イベントの発生源が既にsimplefavorite-buttonの場合は何もしない
        if (e.target.classList.contains('simplefavorite-button')) {
          return;
        }
  
        // favorite-icon内のsimplefavorite-buttonを検索
        const favoriteButton = this.querySelector('.simplefavorite-button');
        if (favoriteButton) {
          // クリックイベントをsimplefavorite-buttonに伝播
          favoriteButton.click();
        }
      });
  
      // カーソルをポインターに変更してクリック可能なことを示す
      icon.style.cursor = 'pointer';
    });
  }); 